const viewportPadding = 16;
const preferredWidth = 900;

document.querySelectorAll<HTMLElement>(".admin-anchor-option").forEach((anchor) => {
  const trigger = anchor.querySelector<HTMLElement>("button");
  const preview = anchor.querySelector<HTMLElement>(".admin-anchor-preview");
  if (!trigger || !preview) return;

  const positionPreview = () => {
    const triggerRect = trigger.getBoundingClientRect();
    const previewWidth = Math.min(preferredWidth, window.innerWidth - viewportPadding * 2);
    const halfWidth = previewWidth / 2;
    const triggerCenter = triggerRect.left + triggerRect.width / 2;
    const center = Math.min(
      Math.max(triggerCenter, viewportPadding + halfWidth),
      window.innerWidth - viewportPadding - halfWidth,
    );

    preview.style.width = `${previewWidth}px`;
    preview.style.left = `${center}px`;
    preview.style.top = `${triggerRect.top}px`;
    preview.style.maxHeight = `${Math.max(240, triggerRect.top - viewportPadding)}px`;
  };

  anchor.addEventListener("mouseenter", positionPreview);
  anchor.addEventListener("focusin", positionPreview);
  window.addEventListener("resize", positionPreview);
});
